
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/switch-to-remote",
      function () {
        return require("private-next-pages/switch-to-remote.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/switch-to-remote"])
      });
    }
  